import Cookies from "js-cookie";
import React, { useEffect, useState } from "react";
import { AiFillEye, AiFillEyeInvisible } from "react-icons/ai";
import { useDispatch, useSelector } from "react-redux";
import { Link, useNavigate } from "react-router-dom";
import loginimg from "../../assets/img/login.gif";
import loginDark from "../../assets/img/login-dark.gif";
import Button from "../../components/Button";
import Footer from "../../components/Footer";
import Header from "../../components/Header";
import Input from "../../components/Input";
import { GET_LOCALSTORAGE_JWT } from "../../config";
import { login } from "../../store/actions/authActions";
const Login = () => {
  const dispatch = useDispatch();
  let navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [value, setValue] = useState({});
  const handleChange = (e) => {
    setValue({ ...value, [e.target.name]: e.target.value });
  };
  const handleSubmit = (e) => {
    e.preventDefault();
    setLoading(true)
    dispatch(login(value, navigate, Cookies, setLoading));
  };
  // theme switch 
  const theme = useSelector(state=>state.theme.theme)
  const [showPassword, setShowPassword] = useState(false);
  useEffect(()=>{
    if(GET_LOCALSTORAGE_JWT("jwt_token")){
      navigate("/")
    }
  },[navigate])
  return (
    <>
      <Header />
      <div className="login_page_wrapper">
        <div style={{ backgroundColor: "#fff" }} className="login_card">
          <div className="section_title">
            <h2>Login</h2>
          </div>
          <div className="login_content">
            <form onSubmit={handleSubmit}>
              <div className="form_group">
                <Input
                  label="Username"
                  type="text"
                  name="username"
                  placeholder="Enter your username"
                  onChange={handleChange}
                  className="userid_input input_field"
                />
              </div>
              <div className="form_group">
                <Input
                  label="Password"
                  type={`${showPassword ? "text" : "password"}`}
                  name="password"
                  placeholder="Enter your password"
                  onChange={handleChange}
                  className="password_input input_field"
                />
                <span onClick={() => setShowPassword(!showPassword)}>
                  {showPassword ? <AiFillEye /> : <AiFillEyeInvisible />}
                </span>
              </div>
              <div className="form_group" style={{ textAlign: "right" }}>
                <Link to="/forgotpassword">Forgot password?</Link>
              </div>
              <Button
                type="submit"
                className="submit_btn glow neon"
                disabled={loading ? true : false}
              >
                {loading ? "Loading..." : "Login"}
              </Button>
              <div className="go_to_register">
                <p>
                  Don't have an account?{" "}
                  <Link to="/register">Create an account</Link>{" "}
                </p>
              </div>
              <div className="go_to_termscondition">
                <p>
                  <Link to="/termsconditions">Terms & Conditions</Link>{" "}
                </p>
              </div>
            </form>
          </div>
        </div>
        <div className="login_banner_img">
          <img src={theme === "dark" ? loginDark : loginimg} width="100%" alt="login" />
        </div>
      </div>
      <Footer />
    </>
  );
};

export default Login;
